import { RootState } from "@redux/store";
import { useEffect } from "react"
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const DashboardRoute = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if(isAuthenticated && user && user.role !== "owner") {
      navigate("/jadwal-loading");
    }
    return () => {}
  }, [isAuthenticated, navigate, user]);
  
  return (
    <div>Dashboard Route</div>
  )
}

export default DashboardRoute